import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./updateBillLealtad.css";
import { TfiAlert } from "react-icons/tfi";
import NoBill from "./NoBillLealtad/NoBillLealtad";

import { RiMailSendLine } from "react-icons/ri";

const UpdateBillLealtad = ({ data }) => {
  const [cbu, setCbu] = useState(data.cbu || "");
  const [numberInvoice, setNumberInvoice] = useState("");
  const [amountToBeTransferred, setAmountToBeTransferred] = useState(0);
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState("");
  const [observation, setObservation] = useState("");
  const [loaderclick, setLoaderClick] = useState(false);
  const [bill, setBill] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("");

  const id = data.id;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SALES_TOTALS_SUPPLIER_LEALTAD}${id}?month=${selectedMonth}&year=2025`
        );

        if (response.status === 204) {
          setAmountToBeTransferred(0);
        } else {
          const data = response.data.salesTotal.totalCommission;
          setAmountToBeTransferred(data);
        }
      } catch (error) {}
    };

    const checkBillStatus = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_CHECK_BILL_URL_LEALTAD}?id=${id}&month=${selectedMonth}`
        );

        if (response.data.invoiceValue === "Cargado") {
          setBill(true);
        } else {
          setBill(false);
        }
      } catch (error) {}
    };

    if (selectedMonth) {
      fetchData();
      checkBillStatus();
    }
  }, [selectedMonth, id]);

  const handleCbuChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setCbu(value);
  };

  const handleNumberInvoiceChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setNumberInvoice(value);
  };

  const handleAmountChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "").replace(/^0+/, "");
    setAmountToBeTransferred(value);
  };

  const handleChangeObservation = (e) => {
    const value = e.target.value;
    setObservation(value ? value : "No hay observaciones");
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setFileUrl(URL.createObjectURL(selectedFile));
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    setLoaderClick(true);

    if (cbu.length !== 22) {
      setLoaderClick(false);
      Swal.fire({
        icon: "error",
        title: "CBU Incorrecto",
        text: "El CBU debe tener 22 números. Por favor, verifique y vuelva a intentarlo.",
      });
      return;
    }

    if (numberInvoice.length < 2) {
      setLoaderClick(false);
      Swal.fire({
        icon: "error",
        title: "Número de Factura Incorrecto",
        text: "El número de factura debe tener al menos 2 dígitos. Por favor, verifique y vuelva a intentarlo.",
      });
      return;
    }

    const endpoint = `${process.env.REACT_APP_INVOICE_SUPPLIER_LEALTAD}`;

    try {
      const formData = new FormData();

      if (file) {
        formData.append("document", file);
        const cleanedFileUrl = fileUrl.replace(/^blob:/, "");
        formData.append("url", cleanedFileUrl);
      }

      formData.append("cbu", cbu);
      formData.append("numberInvoice", numberInvoice);
      formData.append("amountToBeTransferred", amountToBeTransferred);
      formData.append("observation", observation);
      formData.append("month", selectedMonth);
      formData.append("supplierId", id);

      const res = await axios.post(endpoint, formData);
      setLoaderClick(false);
      Swal.fire({
        icon: "success",
        title: "Éxito",
        text: "Se ha subido su factura con éxito." || res.data.message,
      });
      setNumberInvoice("");
      setAmountToBeTransferred(0);
      setFile(null);
      setFileUrl("");
      setBill("Cargado");
    } catch (error) {
      setLoaderClick(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Parece que hubo un error al tratar de enviar la factura.",
      });
    }
  };

  return (
    <div style={{ margin: "auto" }}>
      <div className="boxsearchbillmonthlealtad">
        <select
          className="inputupdateProvbillsearchmonthlealtad"
          onChange={(e) => setSelectedMonth(e.target.value)}
        >
          <option value="">Mes</option>
          <option value="Enero">Enero</option>
          <option value="Febrero">Febrero</option>
          <option value="Marzo">Marzo</option>
          <option value="Abril">Abril</option>
          <option value="Mayo">Mayo</option>
          <option value="Junio">Junio</option>
          <option value="Julio">Julio</option>
          <option value="Agosto">Agosto</option>
          <option value="Septiembre">Septiembre</option>
          <option value="Octubre">Octubre</option>
          <option value="Noviembre">Noviembre</option>
          <option value="Diciembre">Diciembre</option>
        </select>
      </div>

      {amountToBeTransferred === 0 ? (
        <div className="boxdontbilllealtad">
          <TfiAlert className="icondontbilllealtad" />
          <p className="textdontbilllealtad">No hay ventas en este mes.</p>
        </div>
      ) : (
        <>
          {bill === true ? (
            <NoBill
              title="La factura de este mes ya ha sido enviada."
              Icon={RiMailSendLine}
            />
          ) : (
            <div className="boxsearchbillmonthlealtad">
              <div>
                <div className="inputboxlabellealtad">
                  <span className="labelformprovbilllealtad">CBU</span>
                  <input
                    className="inputupdateProvbilllealtad"
                    type="text"
                    maxLength={22}
                    value={cbu}
                    onChange={handleCbuChange}
                  />
                </div>
                <div className="inputboxlabellealtad">
                  <span className="labelformprovbilllealtad">
                    Numero de factura
                  </span>
                  <input
                    className="inputupdateProvbilllealtad"
                    type="number"
                    value={numberInvoice}
                    onChange={handleNumberInvoiceChange}
                  />
                </div>
                <div className="inputboxlabellealtad">
                  <span className="labelformprovbilllealtad">
                    Importe a transferir
                  </span>
                  <input
                    className="inputupdateProvbilllealtad"
                    type="text"
                    disabled
                    value={amountToBeTransferred}
                    onChange={handleAmountChange}
                  />
                </div>
                <div className="inputboxlabellealtad">
                  <span className="labelformprovbilllealtad">
                    Cargar factura
                  </span>
                  <input
                    className="inputupdateProvbilllealtad"
                    type="file"
                    onChange={handleFileChange}
                  />
                </div>

                <div className="inputboxlabellealtad">
                  <span className="labelformprovbilllealtad">Observacion</span>
                  <textarea
                    style={{ height: "100px" }}
                    className="inputupdateProvbilllealtad"
                    maxLength={250}
                    value={observation}
                    onChange={handleChangeObservation}
                  ></textarea>
                </div>

                {loaderclick === true ? (
                  <div className="loaderlittelealtad"></div>
                ) : (
                  <div className="boxbillbuttonlealtad">
                    <button
                      className="updatebillbuttonlealtad"
                      style={{ cursor: "pointer" }}
                      onClick={handleUpload}
                    >
                      Subir archivos
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default UpdateBillLealtad;
